<template>
    <div class="product-type-page" v-if="load">
        <navbar2 />
        <div class="product-type-page-container container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div style="text-align: justify;">
                        <h4 class="title">{{title}}</h4>
                        <p class="disc text-muted">
                            {{description}}
                        </p>
                        <my-button-2 text="Show Demo" style="margin-top: 15px;"/>
                    </div>
                </div>
                <div class="col-lg-6">
                    <img :src="image" style="width: 600px" :alt="title" />
                </div>
            </div>
            <div class="row">
                <h4 class="title col-lg-12"  style="text-align: justify;margin-bottom: 30px;">
                    {{$t('product_type.features')}}
                </h4>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div v-html="features" style="text-align: justify;"></div>
                </div>
            </div>
        </div>
        <order-product /> 
        <custom-footer />
    </div>
    <loader3 v-else />
</template>

<script>
import Navbar2 from "@/components/Navbar2.vue"
import CustomFooter from "@/components/CustomFooter.vue";
import Loader3 from "@/components/Loader3.vue"
import MyButton2 from '@/components/MyButton2.vue';
import OrderProduct from "@/components/OrderProduct.vue"
export default {
    name: "ProductTypePage",
    components: {
        Navbar2,
        CustomFooter,
        Loader3,
        MyButton2,
        OrderProduct
    },
    data() {
        return {
            id: '',
            load: false,
            data: null,
            lang: '',
            title: '',
            description: '',
            type: '',
            features: '',
            image: ''
        };
    },
    methods: {
        getData() {
            this.id = this.$route.params.id
            this.lang = localStorage.getItem("lang")
            this.axios.get(this.$store.state.url + "product_types/" + this.id)
                .then(res => {
                    this.load = true
                    this.data = res.data.list
                    if(this.lang == 'en'){
                        this.title = this.data.title.en
                        this.description = this.data.description.en
                        this.features = this.data.features.en
                        this.type = this.data.type
                        this.image = this.data.image[0]
                    }
                    else{
                        this.title = this.data.title.ar
                        this.description = this.data.description.ar
                        this.features = this.data.features.ar
                        this.type = this.data.type
                        this.image = this.data.image[0]
                    }
                    console.log(this.data)
                });
        }
    },
    mounted() {
        document.documentElement.scrollTop = 0;
        this.getData()
    }
};
</script>

<style>
.product-type-page-container ul{
    list-style-type: disc !important;
}
.product-type-page .product-type-page-image {
    background-image: url(../assets/img/portfolio.webp);
    position: relative;
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
}

/* .product-type-page .overlay {
    height: 100%;
    width: 100%;
    background: linear-gradient(270deg, #126801b6, #15203bce);
} */

.product-type-page .main-title-product-type {
    text-align: center;
    font-weight: bold;
    color: #fff;
    margin-bottom: 60px;
}

@media (min-width: 992px) {
    .product-type-page .main-title-product-type {
        font-size: 50px;
        padding-top: 130px;
    }

    .product-type-page .product-type-page-image {
        height: 80vh;
    }

    .product-type-page .product-type-page-container {
        padding: 60px 20px;
    }
}

@media (max-width: 991px) {
    .product-type-page .main-title-product-type {
        font-size: 30px;
        padding-top: 110px;
    }

    .product-type-page .product-type-page-image {
        height: 60vh;
    }

    .product-type-page .product-type-page-container {
        padding: 50px 30px;
    }
}

.product-type-page .title {
    color: var(--main-blue);
    text-align: justify;
    font-weight: bold;
}

.product-type-page .disc {
    text-align: justify;
    /* font-size: 17px; */
    margin-top: 20px;
}

.product-type-page .before-enter {
    opacity: 0;
    transform: translateY(150px);
    transition: all 2s;
}

.product-type-page .enter {
    opacity: 1;
    transform: translateY(0px);
}
</style>
